import React from 'react';
import { components } from 'react-select';
import { Box } from '../../../Box/Box';
import { Text } from '../../../Text/Text';

export const LoadingMessage = props => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" height={48}>
      <components.LoadingMessage {...props}>
        <Text fontWeight={500} color="neutral.500">
          Loading...
        </Text>
      </components.LoadingMessage>
    </Box>
  );
};
